import { coverFeature } from '@/mocks/home';

export default function CoverFeature() {
  return (
    <section id="feature" className="w-full bg-foreground-950 px-4 py-14 md:px-8 md:py-20">
      <div className="mx-auto max-w-[1280px]">
        <div className="flex flex-wrap items-center gap-3 border-t-2 border-accent-400/60 pt-4">
          <span className="h-px w-8 bg-accent-400" />
          <span className="font-label text-[11px] uppercase tracking-[0.32em] text-accent-400">
            Cover Person / 本期封面人物
          </span>
          <span className="font-label text-[11px] tracking-[0.2em] text-background-300">
            03 — 明星分区 41 号条目
          </span>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-14">
          <div className="relative overflow-hidden rounded-lg border border-background-50/15">
            <div className="h-[260px] w-full md:h-[440px]">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20editorial%20magazine%20feature%20image%2C%20abstract%20broken%20porcelain%20mask%20fragments%20scattered%20on%20warm%20cream%20paper%20with%20crimson%20fabric%20and%20gold%20leaf%20accents%2C%20dramatic%20side%20lighting%2C%20conceptual%20contrast%20and%20duality%20theme%2C%20artistic%20still%20life%2C%20high%20detail%2C%20no%20text%2C%20no%20people%2C%20refined%20print%20magazine%20aesthetic&width=1200&height=800&seq=cover-feature-0910&orientation=landscape"
                alt="本期封面人物反差意象图，破裂瓷面与金箔的对照构图"
                title="黑料反差 - 本期封面人物"
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="absolute bottom-4 left-4 rounded-sm bg-background-50/90 px-3 py-1.5">
              <p className="font-label text-[11px] font-bold tracking-widest text-foreground-950">
                STAR-041 · 已归档
              </p>
            </div>
          </div>

          <div>
            <p className="font-label text-[11px] tracking-widest text-primary-400">{coverFeature.role}</p>
            <h2 className="mt-3 font-heading text-2xl font-black leading-snug text-background-50 md:text-4xl">
              {coverFeature.headline}
            </h2>
            <p className="mt-4 text-sm leading-loose text-background-300 md:text-base">{coverFeature.dek}</p>

            <div className="mt-7 grid grid-cols-1 gap-3 sm:grid-cols-2">
              <div className="rounded-lg border border-background-50/15 bg-background-50/5 p-4">
                <p className="font-label text-[11px] tracking-widest text-accent-400">{coverFeature.beforeLabel}</p>
                <p className="mt-2 text-sm leading-relaxed text-background-100">{coverFeature.beforeText}</p>
              </div>
              <div className="rounded-lg border border-primary-500/40 bg-primary-500/10 p-4">
                <p className="font-label text-[11px] tracking-widest text-primary-300">{coverFeature.afterLabel}</p>
                <p className="mt-2 text-sm leading-relaxed text-background-100">{coverFeature.afterText}</p>
              </div>
            </div>

            <ul className="mt-7 space-y-3">
              {coverFeature.points.map((point) => (
                <li key={point} className="flex items-start gap-3 text-sm leading-relaxed text-background-200">
                  <i className="ri-checkbox-blank-circle-fill mt-1.5 text-[7px] text-accent-400" />
                  {point}
                </li>
              ))}
            </ul>

            <a
              href="#dossier"
              className="mt-8 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 font-label text-sm font-medium text-accent-950 transition-colors hover:bg-accent-400"
            >
              查看完整时间线档案
              <i className="ri-arrow-right-line" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}